import {ActivatedRouteSnapshot, Router} from "@angular/router";
import {ToastService} from "../../../../../../shared/core/services/toast.service";
import {LookupService} from "../../../../../../shared/core/services/lookup.service";
import {ViewModelModelMappingService} from "../../../../../../shared/core/services/view-model-model-mapping.service";
import {PatientService} from "../../../../api/services/patient.service";
import {ViewModelService} from "../../../../../../shared/core/services/view-model.service";
import {Injectable} from "@angular/core";
import {NdmsResolverService} from "../../../../../../shared/core/interfaces/ndmsResolverService";
import {PatientListModelQueryResponseViewModel} from "../../../../api/models/patient-list-model-query-response-view-model";
import * as moment from 'moment';
import {DatetimeService} from "../../../../shared/services/datetime.service";
import {PatientQueryModel} from "../../../../api/models/patient-query-model";
import {FormControl} from "@angular/forms";
import {map} from "rxjs/operators";
import {PatientModelEditorViewModel} from "../../../../api/models/patient-model-editor-view-model";

@Injectable()
export class PatientHomeService  extends NdmsResolverService {
    constructor(
        private apiService: PatientService,
        private lookupService: LookupService,
        private router: Router,
        private toastService: ToastService,
        private viewModelService: ViewModelService,
        private viewModelModelMappingService: ViewModelModelMappingService,
        private datetimeService: DatetimeService) {
        super();
    }

    searchPatientsResults(patientSearchResultsViewModel: any) {
        let queryParams: PatientQueryModel = {
            firstName: patientSearchResultsViewModel.firstName || undefined,
            lastName: patientSearchResultsViewModel.lastName|| undefined,
            gender: patientSearchResultsViewModel.gender || undefined,
            birthDate: patientSearchResultsViewModel.birthDate ? this.datetimeService.formatUploadDate(patientSearchResultsViewModel.birthDate) : undefined,
            identityNumber: patientSearchResultsViewModel.identifierNumber || undefined,
            page: patientSearchResultsViewModel.pageNumber,
            pageSize: patientSearchResultsViewModel.pageSize
        };
        return this.apiService.Query(queryParams).pipe(map((searchResult: PatientListModelQueryResponseViewModel) => {
            return searchResult;
        }));
    }
    getIncomingPatients(){
      return this.apiService.GetIncomingPatients({}).pipe(map((res)=>{
        return res.model;
      }));
    }
  registerPatientAtLocation(registrationData){
      return this.apiService.RegisterIncomingPatient(registrationData).pipe(map((res)=>{
        return res.model;
      }));
  }

  resolve(route: ActivatedRouteSnapshot) {
    return this.apiService.Get().pipe(map((res: PatientModelEditorViewModel) => {
      this.lookupService.loadLookups(res.lookups);
    }));
  }
}
